import React from 'react';
import { ShieldAlert, CheckCircle2, ChevronRight } from 'lucide-react';
export function SideRearGlass() {
  const commonDamage = ['Driver side window shattered', 'Passenger side window broken', 'Rear window shattered', 'Car door glass broken', 'Quarter glass damage', 'Truck rear glass broken', 'Van or fleet vehicle glass damage'];
  const kosinsConfirms = ['Vehicle year, make and model', 'Which glass is broken', 'Whether power-window parts are involved', 'Glass availability', 'Insurance details', 'Appointment availability', 'Drop-off or service options'];
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-264">
      <div className="max-w-7xl mx-auto" data-id="element-265">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-266">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-4 tracking-tight leading-tight" data-id="element-267">
            <span className="text-brand-red" data-id="element-268">Side Window Shattered?</span> Rear
            Window Broken?
          </h2>
          <p className="text-lg text-slate-600" data-id="element-269">
            Broken side or rear vehicle glass can expose your vehicle to
            weather, theft risk and safety concerns. Kosin's Glass replaces side
            windows, power window glass, car door glass, quarter glass and rear
            windows for many vehicle types.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-270">
          {/* Left Column */}
          <div className="bg-slate-50 rounded-xl p-6 sm:p-8 border border-slate-200" data-id="element-271">
            <h3 className="text-xl font-bold text-slate-900 mb-6 flex items-center gap-2.5" data-id="element-272">
              <ShieldAlert className="w-6 h-6 text-brand-red" data-id="element-273" />
              Common urgent glass damage
            </h3>
            <ul className="space-y-3" data-id="element-274">
              {commonDamage.map((item, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-275">
                  <ChevronRight className="w-5 h-5 text-brand-red shrink-0 mt-0.5" data-id="element-276" />
                  <span className="text-slate-700" data-id="element-277">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Right Column */}
          <div className="bg-slate-50 rounded-xl p-6 sm:p-8 border border-slate-200" data-id="element-278">
            <h3 className="text-xl font-bold text-slate-900 mb-6 flex items-center gap-2.5" data-id="element-279">
              <CheckCircle2 className="w-6 h-6 text-brand-red" data-id="element-280" />
              What Kosin's will confirm
            </h3>
            <ul className="space-y-3" data-id="element-281">
              {kosinsConfirms.map((item, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-282">
                  <span className="shrink-0 mt-0.5 w-5 h-5 rounded-full border-2 border-brand-red flex items-center justify-center" data-id="element-283">
                    <CheckCircle2 className="w-3 h-3 text-brand-red" strokeWidth={3} data-id="element-284" />
                  </span>
                  <span className="text-slate-700" data-id="element-285">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="text-center" data-id="element-286">
          <a href="#quote-form" className="inline-flex items-center justify-center gap-2 bg-brand-red hover:bg-brand-redHover text-white px-7 py-4 rounded-lg font-bold text-base transition-colors shadow-sm" data-id="element-287">
            Get a Side or Rear Window Quote
          </a>
        </div>
      </div>
    </section>;
}